"use strict";
import { isRNDev } from "utilities/src/environment/env";
export const isJestRun = !!process.env.JEST_WORKER_ID;
export const isNonJestDev = isRNDev() && !isJestRun;
